
import {defineComponent, onMounted, reactive, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useToast} from "primevue/usetoast";
import {ValidationButtonSettingsDto} from "@dex/squeeze-client-ts";
import ButtonNameEnum = ValidationButtonSettingsDto.ButtonNameEnum;
import {ClientManager} from "@/singletons/ClientManager";
import {ToastManager} from "@/util/ToastManager";
import BlockUI from 'primevue/blockui';
import SystemValidationButtonSettingsForm from "@/apps/administration/components/system/SystemValidationButtonSettingsForm.vue";

export default defineComponent({
	name: "SystemValidationButtonSettingsView",
	components: {BlockUI, SystemValidationButtonSettingsForm},
	setup() {
		const {t} = useI18n();
		const toast = useToast();

		/** Api for validation */
		const validationApi = ClientManager.getInstance().squeeze.validation;

		/** Show Loading on load data */
		const loading = ref(false);

		/** Current Array with all input-fields */
		const value = reactive({
			settings: [
				{
					buttonName: ButtonNameEnum.Validate,
					description: '',
					color: '',
					icon: '',
				},
				{
					buttonName: ButtonNameEnum.Suspend,
					description: '',
					color: '',
					icon: '',
				},
				{
					buttonName: ButtonNameEnum.Delete,
					description: '',
					color: '',
					icon: '',
				},
			] as ValidationButtonSettingsDto[],
		});

		/** Get all validation button settings */
		const getValidationButtonSettings = () => {
			loading.value = true;
			validationApi.getValidationButtonSettings()
				.then(buttonSettings => {
					if (!buttonSettings.length) {
						return;
					}

					buttonSettings.forEach((setting) => {
						const settingIndex = value.settings.findIndex((data: ValidationButtonSettingsDto) => data.buttonName === setting.buttonName);
						value.settings[settingIndex] = setting;
					});
				}).catch(response => response.json().then ((error: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + error.message);
				})).finally(() => {
					loading.value = false;
				})
		}

		onMounted(() => {
			getValidationButtonSettings();
		})

		return {
			t,
			toast,
			loading,
			value,
		}
	},
})
